import {
    CONSTANTS,
    GRAPH_TYPES,
    REPORT_TYPES,
    VERTICALS,
} from "../../../constants/app-constant";
import { groupBy } from "../../../utility/common-methods";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";

const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, AREA } = GRAPH_TYPES;

const {
    REPORTS: { TYPES },
} = CONSTANTS;




export const formatSpokesPersonData = (d = [], graphType,
    isLineGraph,
    type,
    report_type,
    isEmbededWidget = false) => {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
        graphDataType: { print, online },
        groupByField,
        entityKey,
        countKey,
    } = reportType;
    if (graphType === BAR_STACKED_EQUAL_HEIGHT) {
        const result = d;
        const journalist = result && result[result.sequence[0]].returnData.journalist;

        let labels = [];
        const dataSet = [];
        const dataObj = result && result[result?.sequence[0]].returnData?.graphdata;
        const resultLabels = Object.keys(dataObj);
        const color = dataObj && getRandomUniqueColor(dataObj.length);
        const staticLables = ["print", "online"];
        staticLables.forEach((lab, idx) => {
            const data = [];
            const barThickness = "flex";
            const borderColor = color[idx];
            const backgroundColor = color[idx];
            const borderWidth = 1;
            let label = lab;

            dataObj && dataObj.forEach((ent, index) => {
                if (index < 10) {
                    labels.push(Object.keys(ent)[0]);
                    if (dataObj[index][Object.keys(ent)[0]].hasOwnProperty(lab)) {
                        if (parseInt(dataObj[index][Object.keys(ent)[0]][lab][countKey]) > 0) {
                            const currValEnt = parseInt(dataObj[index][Object.keys(ent)[0]][lab][countKey]);
                            data.push(currValEnt);
                        }
                    }
                    else {
                        data.push(0);
                    }
                }
            });
            dataSet.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill: false, lineTension: 0 });
        });
        console.log("labels", labels)
        console.log('dataSet', dataSet)
        return ({ labels, datasets: dataSet });
    }
    if (graphType === TABLE) {
        const result = d;
        const entities = result && result[result.sequence[0]].returnData.entities;
        const color = entities && getRandomUniqueColor(entities.length);
        let labels = ["Company Name"];
        const dataSet = [];
        const dataObj = result[result?.sequence[0]].returnData?.graphdata;
        const resultLabels = Object.keys(dataObj);
        labels = [...labels, ...resultLabels];
        const labelData = {};
        resultLabels.forEach((label) => {
            labelData[label] = {};
            entities.forEach((ent) => {
                labelData[label][ent.entity_name] = {};
                if (dataObj[label].hasOwnProperty(ent.entity_name)) {
                    const currVal = parseFloat(dataObj[label][ent.entity_name].indexPerc, 10);
                    labelData[label][ent.entity_name] = { indexPerc: currVal };
                }
                else {
                    labelData[label][ent.entity_name] = { indexPerc: 0 };
                }
            });
        });

        //Ranking Logic
        const labelObj = {};
        Object.keys(labelData).forEach((label) => {
            const labelVals = [];
            entities.forEach((ent) => {
                labelVals.push(labelData[label][ent.entity_name].indexPerc);
            });
            labelVals.sort((a, b) => (a > b) ? -1 : 1);
            labelObj[label] = labelVals;
        });

        entities.forEach((entity) => {
            const colEntry = [entity.entity_name];
            resultLabels.forEach((label) => {
                if (dataObj[label].hasOwnProperty(entity.entity_name)) {
                    const currEntry = parseFloat(dataObj[label][entity.entity_name].indexPerc, 10);
                    const currRank = labelObj[label].indexOf(currEntry) + 1;
                    colEntry.push(currRank);
                }
                else {
                    colEntry.push("-");
                }
            });
            dataSet.push(colEntry);
        });
        return { labels, datasets: dataSet };
    }
}

